export default __webpack_public_path__ + "static/media/hht2_ep08_timeline_q02_a.46e8d865.png";